export default "__VITE_ASSET__5mun2obN__"